<template>

    <section v-if="quoteRequest && quoteRequest.company && quoteRequest.items && taxKeys">
        <div class="container">
            <div class="page-header">
                Please quote on the following items.
                Any questions, <a class="" v-on:click="$emit('toggleMessagePane', true)">send a message</a>
            </div>
            <div class="items-list-box is-hidden-mobile">
                <table class="items-list">
                    <thead>
                        <th width="auto">Description</th>
                        <th class="th-centered" width="30">Qty</th>
                        <th class="th-centered" width="90">UOM</th>
                        <th class="th-centered" width="130">Total Amount</th>
                        <th v-if="(quoteRequest.calculationMethod >= 1)" class="th-centered" width="140">Rate</th>
                        <th v-if="computedRegisteredForTax || (quoteRequest.calculationMethod >= 1)" class="th-centered" width="180">{{quoteRequest.company.taxCode}}</th>
                    </thead>
                    <tbody>
                        <template v-for="(item, index) in quoteRequest.items">
                            <!-- v-if="true" because the linter is bugged -->
                            <tr v-if="true" :key="item.requestItemId">
                                <td>
                                    <strong>{{index+1}}</strong> - {{item.description}}
                                </td>
                                <td class="td-centered">
                                    <template v-if="!item.isRecipe">
                                        {{item.quantity}}
                                    </template>
                                </td>
                                <td class="td-centered">
                                    {{item.uom || 'N/A'}}
                                </td>
                                <td>
                                    <template v-if="!item.isRecipe">
                                        <strong class='currencyPrefix'>{{currencySymbol}}</strong>
                                        <input class="input is-inline" style="width: 90px" type="number" inputmode="numeric" min="0" step="0.01"
                                                    :value="$store.state.data.items[index].response.total"
                                                    v-bind:data-ref="index" @input="updateItemAmount" :name="`Amount ${index + 1}`" v-validate="{ required: true, decimal: true }" v-bind:disabled="reopenVisible" :placeholder="`Amount ${index + 1}`">
                                        <span style="display: block" v-show="errors.has(`Amount ${index + 1}`)" class="has-text-danger">Input required</span>
                                    </template>
                                    <template v-else>
                                        <strong class='currencyPrefix'>{{currencySymbol}}</strong>
                                        <input class="input is-inline" style="width: 90px" type="number" inputmode="numeric"
                                            :value="$store.state.data.items[index].response.total" disabled readonly>
                                    </template>
                                </td>
                                <td v-if="quoteRequest.calculationMethod >= 1">
                                    <template v-if="!item.isRecipe || quoteRequest.calculationMethod === 1">
                                        <div class="dropdown" v-bind:class="{'is-active': (dropdownRateActive[index])}">
                                            <div style="margin-left: 5px;" class="dropdown-trigger">
                                                <button class="button" style="min-width: 140px" @click="toggleRateDropdown(index, $event)" v-bind:data-ref="index" aria-haspopup="true" v-bind:disabled="reopenVisible" v-bind:aria-controls="`dropdown-menu1_${index}`">
                                                    <span>{{selectedTaxRate(item)}}</span>
                                                    <span class="icon is-small">
                                                        <i class="fas fa-angle-down" aria-hidden="true"></i>
                                                    </span>
                                                </button>
                                            </div>
                                            <div class="dropdown-menu" v-bind:id="`dropdown-menu1_${index}`" role="menu">
                                                <div class="dropdown-content">
                                                    <a v-if="aggregateTaxRate(item.costItemType) !== null" @click="dropdownSelectAggregate(index)" class="dropdown-item">
                                                        <b>{{aggregateTaxRate(item.costItemType).codes}}</b> ({{aggregateTaxRate(item.costItemType).rate * 100}}%)
                                                    </a>
                                                    <a v-if="$store.state.taxRateExempt !== null" @click="dropdownSelectExempt(index)" class="dropdown-item">
                                                        <b>{{$store.state.taxRateExempt.code}}</b> ({{$store.state.taxRateExempt.rate * 100}}%)
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </td>
                                <td v-if="computedRegisteredForTax || (quoteRequest.calculationMethod >= 1)">
                                    <!--{{index}} - {{taxKeys[index]}} - {{item.response.taxStatus}}-->
                                    <div class="dropdown" v-bind:class="{'is-active': (dropdownActive[index])}">
                                        <template v-if="!item.isRecipe || quoteRequest.calculationMethod < 2">
                                            <div style="margin-left: 5px;" class="dropdown-trigger">
                                                <button class="button" style="min-width: 94px" @click="toggleDropdown(index, $event)" v-bind:data-ref="index" aria-haspopup="true" v-bind:disabled="reopenVisible" v-bind:aria-controls="`dropdown-menu2_${index}`">
                                                    <span>{{taxKeys[item.response.taxStatus] || 'Inc'}}</span>
                                                    <span class="icon is-small">
                                                        <i class="fas fa-angle-down" aria-hidden="true"></i>
                                                    </span>
                                                </button>
                                            </div>
                                            <div class="dropdown-menu" v-bind:id="`dropdown-menu2_${index}`" role="menu">
                                                <div class="dropdown-content">
                                                    <a @click="dropdownSelectOption({index: index, value: 1})" class="dropdown-item">
                                                        {{taxKeys[1]}}
                                                    </a>
                                                    <a @click="dropdownSelectOption({index: index, value: 0})" class="dropdown-item">
                                                        {{taxKeys[0]}}
                                                    </a>
                                                    <a v-if="quoteRequest.calculationMethod === 0"
                                                      @click="dropdownSelectOption({index: index, value: 2})" class="dropdown-item">
                                                        {{taxKeys[2]}}
                                                    </a>
                                                </div>
                                            </div>
                                        </template>
                                        <div :style="{ marginLeft: !item.isRecipe || quoteRequest.calculationMethod < 2 ? '5px' : '104px' }">
                                            <div class="control">
                                                <input class="input" disabled type="text" style="width: 80px" :value="$n($store.state.data.items[index].response.tax, 'currency')" readonly>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <template v-if="item.isRecipe">
                                <tr class="recipe-item" v-for="(recipeItem, rIndex) in item.recipeItems" :key="recipeItem.requestRecipeItemId">
                                    <td class="recipe-item-description">
                                        <strong>{{index+1}}.{{rIndex+1}}</strong> - {{recipeItem.description}}
                                    </td>
                                    <td class="td-centered">
                                        {{recipeItem.quantity}}
                                    </td>
                                    <td class="td-centered">
                                        {{recipeItem.uom || 'N/A'}}
                                    </td>
                                    <td>
                                        <strong class='currencyPrefix'>{{currencySymbol}}</strong>
                                        <input class="input is-inline" style="width: 90px" type="number" inputmode="numeric" min="0" step="0.01"
                                                    :value="$store.state.data.items[index].recipeItems[rIndex].response.total"
                                                    v-bind:data-ref="`${index},${rIndex}`" @input="updateRecipeItemAmount"
                                                    :name="`Amount ${index+1}.${rIndex+1}`" v-validate="{ required: true, decimal: true }" v-bind:disabled="reopenVisible"
                                                    :placeholder="`Amount ${index+1}.${rIndex+1}`">
                                        <span style="display: block" v-show="errors.has(`Amount ${index+1}.${rIndex+1}`)" class="has-text-danger">Input required</span>
                                    </td>
                                    <td v-if="quoteRequest.calculationMethod >= 1">
                                        <template v-if="quoteRequest.calculationMethod >= 2">
                                            <div class="dropdown" v-bind:class="{'is-active': (dropdownRateActive[`${index}.${rIndex}`])}">
                                                <div style="margin-left: 5px;" class="dropdown-trigger">
                                                    <button class="button" style="min-width: 140px" @click="toggleRateDropdown(`${index}.${rIndex}`, $event)" :data-ref="`${index}.${rIndex}`" aria-haspopup="true" v-bind:disabled="reopenVisible" v-bind:aria-controls="`dropdown-menu1_${index}_${rIndex}`">
                                                        <span>{{selectedTaxRate(recipeItem)}}</span>
                                                        <span class="icon is-small">
                                                            <i class="fas fa-angle-down" aria-hidden="true"></i>
                                                        </span>
                                                    </button>
                                                </div>
                                                <div class="dropdown-menu" v-bind:id="`dropdown-menu1_${index}_${rIndex}`" role="menu">
                                                    <div class="dropdown-content">
                                                        <a v-if="aggregateTaxRate(recipeItem.costItemType) !== null" @click="dropdownSelectAggregate(index, rIndex)" class="dropdown-item">
                                                            <b>{{aggregateTaxRate(recipeItem.costItemType).codes}}</b> ({{aggregateTaxRate(recipeItem.costItemType).rate * 100}}%)
                                                        </a>
                                                        <a v-if="$store.state.taxRateExempt !== null" @click="dropdownSelectExempt(index, rIndex)" class="dropdown-item">
                                                            <b>{{$store.state.taxRateExempt.code}}</b> ({{$store.state.taxRateExempt.rate * 100}}%)
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </td>
                                    <td v-if="computedRegisteredForTax || (quoteRequest.calculationMethod >= 1)">
                                        <template v-if="quoteRequest.calculationMethod >= 2">
                                            <div class="dropdown" v-bind:class="{'is-active': (dropdownActive[`${index}.${rIndex}`])}">
                                                <div style="margin-left: 5px;" class="dropdown-trigger">
                                                    <button class="button" style="min-width: 94px" @click="toggleDropdown(`${index}.${rIndex}`, $event)" :data-ref="`${index}.${rIndex}`" aria-haspopup="true" v-bind:disabled="reopenVisible" v-bind:aria-controls="`dropdown-menu2_${index}_${rIndex}`">
                                                        <span>{{taxKeys[recipeItem.response.taxStatus] || 'Inc'}}</span>
                                                        <span class="icon is-small">
                                                            <i class="fas fa-angle-down" aria-hidden="true"></i>
                                                        </span>
                                                    </button>
                                                </div>
                                                <div class="dropdown-menu" v-bind:id="`dropdown-menu2_${index}_${rIndex}`" role="menu">
                                                    <div class="dropdown-content">
                                                        <a @click="dropdownSelectOption({index, rIndex, value: 1})" class="dropdown-item">
                                                            {{taxKeys[1]}}
                                                        </a>
                                                        <a @click="dropdownSelectOption({index, rIndex, value: 0})" class="dropdown-item">
                                                            {{taxKeys[0]}}
                                                        </a>
                                                        <a v-if="quoteRequest.calculationMethod === 0"
                                                          @click="dropdownSelectOption({index, rIndex, value: 2})" class="dropdown-item">
                                                            {{taxKeys[2]}}
                                                        </a>
                                                    </div>
                                                </div>
                                                <div style="margin-left: 5px;">
                                                    <div class="control">
                                                        <input class="input" disabled type="text" style="width: 80px" :value="$n($store.state.data.items[index].recipeItems[rIndex].response.tax, 'currency')" readonly>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
            </div>
            <div class="is-hidden-tablet">
                <div class="owl-carousel">
                    <div v-for="(item, index) in quoteRequest.items" v-bind:key="index" class="section-items-carousel-item">
                    <ul>
                        <li>
                            <label class="left">Description</label>
                            <div class="item-value-touch">{{item.description}}</div>
                        </li>
                        <li v-if="!item.isRecipe">
                            <label class="left">Qty</label>
                            <div class="item-value-touch">{{item.quantity}}</div>
                        </li>
                        <li>
                            <label class="left">UOM</label>
                            <div class="item-value-touch">{{item.uom || 'N/A'}}</div>
                        </li>
                        <li>
                            <label class="left">Amount</label>
                            <template v-if="!item.isRecipe">
                                <div class="item-value-touch">
                                    <strong class='currencyPrefix'>{{currencySymbol}}</strong>
                                    <input class="input is-inline" style="width: 90px" type="number" inputmode="numeric" min="0" step="0.01"
                                            :value="$store.state.data.items[index].response.total"
                                            v-bind:data-ref="index" @input="updateItemAmount" :name="`Amount ${index + 1}`" v-validate="{ required: true, decimal: true }" v-bind:disabled="reopenVisible" :placeholder="`Amount ${index + 1}`">
                                    <span style="display: block" v-show="errors.has(`Amount ${index + 1}`)" class="has-text-danger">Input required</span>
                                </div>
                            </template>
                                <template v-else>
                                <span style="width: 90px">{{$n($store.state.data.items[index].response.total, 'currency')}}</span>
                            </template>
                        </li>
                        <li v-if="quoteRequest.calculationMethod === 1 || (!item.isRecipe && quoteRequest.calculationMethod >= 2)">
                            <label class="left">Rate</label>
                            <div class="item-value-touch control">
                                <label v-if="aggregateTaxRate(item.costItemType) !== null" class="radio">
                                    <input type="radio"
                                           @click="dropdownSelectAggregate(index)"
                                           :name="`mbl-rate-${index}`" :checked="item.response.taxRates === aggregateTaxRate(item.costItemType).selected">
                                    &nbsp;<b>{{aggregateTaxRate(item.costItemType).codes}}</b> ({{aggregateTaxRate(item.costItemType).rate * 100}}%)
                                </label>
                                <label v-if="$store.state.taxRateExempt !== null" class="radio">
                                    <input type="radio"
                                           @click="dropdownSelectExempt(index)"
                                           :name="`mbl-rate-${index}`" :checked="item.response.taxRates === $store.state.taxRateExempt.selected">
                                    &nbsp;<b>{{$store.state.taxRateExempt.code}}</b> ({{$store.state.taxRateExempt.rate * 100}}%)
                                </label>
                            </div>
                        </li>
                        <li v-if="(computedRegisteredForTax || quoteRequest.calculationMethod >= 1) && (!item.isRecipe || quoteRequest.calculationMethod < 2)">
                            <label class="left">{{quoteRequest.company.taxCode}}</label>
                            <div class="item-value-touch control">
                                <label class="radio">
                                    <input type="radio"
                                           @click="dropdownSelectOption({index, value: 1})"
                                           :name="`mbl-tax-${index}`" :checked="item.response.taxStatus === 1">
                                    {{taxKeys[1]}}
                                </label>
                                <label class="radio">
                                    <input type="radio"
                                           @click="dropdownSelectOption({index, value: 0})"
                                           :name="`mbl-tax-${index}`" :checked="item.response.taxStatus === 0">
                                    {{taxKeys[0]}}
                                </label>
                                <label v-if="quoteRequest.calculationMethod === 0" class="radio">
                                    <input type="radio"
                                           @click="dropdownSelectOption({index, value: 2})"
                                           :name="`mbl-tax-${index}`" :checked="item.response.taxStatus === 2">
                                    {{taxKeys[2]}}
                                </label>
                            </div>
                        </li>
                    </ul>
                    <template v-if="item.isRecipe">
                        <div v-for="(recipeItem, rIndex) in item.recipeItems" :key="recipeItem.requestRecipeItemId">
                          <hr>
                          <ul>
                              <li>
                                  <label class="left">Description</label>
                                  <div class="item-value-touch">{{recipeItem.description}}</div>
                              </li>
                              <li>
                                  <label class="left">Qty</label>
                                  <div class="item-value-touch">{{recipeItem.quantity}}</div>
                              </li>
                              <li>
                                  <label class="left">UOM</label>
                                  <div class="item-value-touch">{{recipeItem.uom || 'N/A'}}</div>
                              </li>
                              <li>
                                  <label class="left">Amount</label>
                                  <div class="item-value-touch">
                                      <strong class='currencyPrefix'>{{currencySymbol}}</strong>
                                      <input class="input is-inline" style="width: 90px" type="number" inputmode="numeric" min="0" step="0.01"
                                              :value="$store.state.data.items[index].recipeItems[rIndex].response.total"
                                              v-bind:data-ref="`${index},${rIndex}`" @input="updateRecipeItemAmount"
                                              :name="`Amount ${index+1}.${rIndex+1}`" v-validate="{ required: true, decimal: true }" v-bind:disabled="reopenVisible"
                                              :placeholder="`Amount ${index+1}.${rIndex+1}`">
                                      <span style="display: block" v-show="errors.has(`Amount ${index+1}.${rIndex+1}`)" class="has-text-danger">Input required</span>
                                  </div>
                              </li>
                              <template v-if="quoteRequest.calculationMethod >= 2">
                                  <li>
                                      <label class="left">Rate</label>
                                      <div class="item-value-touch control">
                                          <label v-if="aggregateTaxRate(recipeItem.costItemType) !== null" class="radio">
                                              <input type="radio"
                                                    @click="dropdownSelectAggregate(index, rIndex)"
                                                    :name="`mbl-rate-${index}-${rIndex}`" :checked="recipeItem.response.taxRates === aggregateTaxRate(recipeItem.costItemType).selected">
                                              &nbsp;<b>{{aggregateTaxRate(recipeItem.costItemType).codes}}</b> ({{aggregateTaxRate(recipeItem.costItemType).rate * 100}}%)
                                          </label>
                                          <label v-if="$store.state.taxRateExempt !== null" class="radio">
                                              <input type="radio"
                                                    @click="dropdownSelectExempt(index, rIndex)"
                                                    :name="`mbl-rate-${index}-${rIndex}`" :checked="recipeItem.response.taxRates === $store.state.taxRateExempt.selected">
                                              &nbsp;<b>{{$store.state.taxRateExempt.code}}</b> ({{$store.state.taxRateExempt.rate * 100}}%)
                                          </label>
                                      </div>
                                  </li>
                                  <li>
                                      <label class="left">{{quoteRequest.company.taxCode}}</label>
                                      <div class="item-value-touch control">
                                          <label class="radio">
                                              <input type="radio"
                                                    @click="dropdownSelectOption({index, rIndex, value: 1})"
                                                    :name="`mbl-tax-${index}-${rIndex}`" :checked="recipeItem.response.taxStatus === 1">
                                              {{taxKeys[1]}}
                                          </label>
                                          <label class="radio">
                                              <input type="radio"
                                                    @click="dropdownSelectOption({index, rIndex, value: 0})"
                                                    :name="`mbl-tax-${index}-${rIndex}`" :checked="recipeItem.response.taxStatus === 0">
                                              {{taxKeys[0]}}
                                          </label>
                                      </div>
                                  </li>
                              </template>
                          </ul>
                        </div>
                    </template>
                    </div>
                </div>
                <figure class="has-text-centered">{{computedStepText}}</figure>
            </div>
        </div>
    </section>
</template>

<script>
//
import $ from 'jquery'
// eslint-disable-next-line no-unused-vars
import owlCarousel from 'owl.carousel' /* We just have to IMPORT this even if we are not initiating by using it. */
import Vue from 'vue'
import getSymbolFromCurrency from 'currency-symbol-map'

export default {
  name: 'section-items',
  components: {},
  props: ['quoteRequest', 'reopenVisible', 'dateSubmitted', 'dateDeadline', 'step', 'stepReached'],
  inject: ['$validator'],
  mounted () {
    // $(document).ready(() => {
    this.ready = true
    // Owl nav custom container here to be outside of paddings
    $('.owl-arrows > *').remove()
    Vue.nextTick(() => {
      $('.owl-carousel').owlCarousel({
        items: 1,
        nav: true,
        navContainer: '.owl-arrows',
        dots: false
      })

      $('.owl-carousel').on('changed.owl.carousel', (event) => {
        this.owlIndex = event.item.index + 1
      })
    })
  },
  data () {
    return {
      dropdownActive: {},
      dropdownRateActive: {},
      ready: false,
      owlEventItem: null,
      owlIndex: 1
    }
  },
  methods: {
    updateItemAmount (e) {
      let index = +e.target.attributes['data-ref'].value
      let inputValue = +e.target.value
      this.$store.commit('updateItemAmount', {index, value: inputValue})
      this.recalcTotalAndTax(index)
    },
    updateRecipeItemAmount (e) {
      let [index, rIndex] = e.target.attributes['data-ref'].value.split(',').map(i => +i)
      let inputValue = +e.target.value
      this.$store.commit('updateRecipeItemAmount', {index, rIndex, value: inputValue})
      this.recalcTotalAndTax(index, rIndex)
      this.recalcRecipe(index)
    },
    toggleDropdown (index, e) {
      e.preventDefault()
      const sIndex = `${index}`
      for (let s in this.dropdownActive) {
        if (s !== sIndex) {
          Vue.set(this.dropdownActive, s, false)
        }
      }
      Vue.set(this.dropdownActive, sIndex, !this.dropdownActive[sIndex])
    },
    dropdownSelectOption (obj) {
      const {index, rIndex} = obj
      if (rIndex === undefined) {
        this.$store.commit('updateItemResponseTaxStatus', obj)
        if (this.quoteRequest.items[index].isRecipe) {
          this.updateRecipeItemsTaxes(index)
        } else {
          this.recalcTotalAndTax(index)
        }
        Vue.set(this.dropdownActive, index, false)
      } else {
        this.$store.commit('updateRecipeItemResponseTaxStatus', obj)
        this.recalcTotalAndTax(index, rIndex)
        this.recalcRecipe(index)
        Vue.set(this.dropdownActive, `${index}.${rIndex}`, false)
      }
    },
    toggleRateDropdown (index, e) {
      e.preventDefault()
      const sIndex = `${index}`
      for (let s in this.dropdownRateActive) {
        if (s !== sIndex) {
          Vue.set(this.dropdownRateActive, s, false)
        }
      }
      Vue.set(this.dropdownRateActive, sIndex, !this.dropdownRateActive[sIndex])
    },
    dropdownSelectExempt (index, rIndex = null) {
      if (rIndex === null) {
        this.$store.commit('updateItemResponseTaxRates', {index, value: this.$store.state.taxRateExempt.selected})
        if (this.quoteRequest.items[index].isRecipe) {
          this.updateRecipeItemsTaxes(index)
        } else {
          this.recalcTotalAndTax(index)
        }
        Vue.set(this.dropdownRateActive, index, false)
      } else {
        this.$store.commit('updateRecipeItemResponseTaxRates', {index, rIndex, value: this.$store.state.taxRateExempt.selected})
        this.recalcTotalAndTax(index, rIndex)
        this.recalcRecipe(index)
        Vue.set(this.dropdownRateActive, `${index}.${rIndex}`, false)
      }
    },
    dropdownSelectAggregate (index, rIndex = null) {
      const item = rIndex === null ? this.quoteRequest.items[index] : this.quoteRequest.items[index].recipeItems[rIndex]
      const selectedRate = this.$store.state.taxRatesAggregates[item.costItemType].selected
      if (rIndex === null) {
        this.$store.commit('updateItemResponseTaxRates', {index, value: selectedRate})
        if (this.quoteRequest.items[index].isRecipe) {
          this.updateRecipeItemsTaxes(index)
        } else {
          this.recalcTotalAndTax(index)
        }
        Vue.set(this.dropdownRateActive, index, false)
      } else {
        this.$store.commit('updateRecipeItemResponseTaxRates', {index, rIndex, value: selectedRate})
        this.recalcTotalAndTax(index, rIndex)
        this.recalcRecipe(index)
        Vue.set(this.dropdownRateActive, `${index}.${rIndex}`, false)
      }
    },
    aggregateTaxRate (itemType) {
      return this.$store.state.taxRatesAggregates[itemType]
    },
    selectedTaxRate (item) {
      if (item && item.response && item.response.taxRates) {
        let rateArray = JSON.parse(item.response.taxRates)
        if (rateArray) {
          let taxRate = 0
          const selectedJoin = rateArray.join(', ')
          if (rateArray.length > 0) {
            if (
              this.$store.state.taxRatesAggregates &&
              this.$store.state.taxRatesAggregates[item.costItemType] &&
              this.$store.state.taxRatesAggregates[item.costItemType].codes === selectedJoin
            ) {
              taxRate = this.$store.state.taxRatesAggregates[item.costItemType].rate
            }
          }

          return selectedJoin + ' (' + (taxRate * 100) + '%)'
        }
      }

      return ''
    },
    recalcRecipe (index) {
      const recipe = this.quoteRequest.items[index]
      let total = 0
      let tax = 0
      let totalIncTax = 0
      recipe.recipeItems.forEach(recipeItem => {
        total += recipeItem.response.total || 0
        tax += recipeItem.response.tax || 0
        totalIncTax += recipeItem.response.totalIncTax || 0
      })
      this.$store.commit('updateItemAmount', {index, value: total})
      this.$store.commit('updateItemTax', {index, value: tax})
      this.$store.commit('updateItemTotalIncTax', {index, value: totalIncTax})
    },
    recalcTotalAndTax (index, rIndex = null, overrideCostItemType = null) {
      // Update the tax on this item based on the tax status for this item.
      let item = rIndex === null ? this.quoteRequest.items[index] : this.quoteRequest.items[index].recipeItems[rIndex]
      let costItemType = overrideCostItemType || item.costItemType
      let amount = item.response.total
      let tax = 0
      let additionalTax = 0
      let value = item.response.taxStatus
      let taxRate = this.quoteRequest.company.taxRate
      if (this.quoteRequest.calculationMethod >= 1) {
        let selectedCode = item.response.taxRates
        if (selectedCode) {
          let selectedArray = JSON.parse(selectedCode)
          if (selectedArray && (selectedArray.length > 0)) {
            if ((selectedArray.length === 1) && this.$store.state.taxRateExempt && (this.$store.state.taxRateExempt.code === selectedArray[0])) {
              taxRate = this.$store.state.taxRateExempt.rate
            } else {
              let selectedJoin = selectedArray.join(', ')
              if (this.$store.state.taxRatesAggregates && (this.$store.state.taxRatesAggregates[costItemType].codes === selectedJoin)) {
                taxRate = this.$store.state.taxRatesAggregates[costItemType].rate
              }
            }
          }
        }
      }

      if (this.computedRegisteredForTax || (this.quoteRequest.calculationMethod >= 1)) {
        if (item.response.taxStatus === 0) {
          // Inc GST
          tax = amount - (amount / (1 + taxRate))
        } else if (value === 1) {
          // Ex GST
          tax = additionalTax = amount * taxRate
        } else {
          tax = 0
        }
      }

      if (tax && !isNaN(tax)) { tax = Math.round(tax * 100) / 100 } // Round to 2 decimal places.
      if (rIndex === null) {
        this.$store.commit('updateItemTax', {index, value: tax})
        this.$store.commit('updateItemTotalIncTax', {index, value: +amount + +additionalTax})
      } else {
        this.$store.commit('updateRecipeItemTax', {index, rIndex, value: tax})
        this.$store.commit('updateRecipeItemTotalIncTax', {index, rIndex, value: +amount + +additionalTax})
      }
    },
    updateRecipeItemsTaxes (index) {
      const item = this.quoteRequest.items[index]
      const {taxStatus, taxRates} = item.response
      item.recipeItems.forEach((_, rIndex) => {
        this.$store.commit('updateRecipeItemResponseTaxStatus', {index, rIndex, value: taxStatus})
        this.$store.commit('updateRecipeItemResponseTaxRates', {index, rIndex, value: taxRates})
        this.recalcTotalAndTax(index, rIndex, this.quoteRequest.calculationMethod < 2 ? item.costItemType : null)
      })
      this.recalcRecipe(index)
    }
  },
  computed: {
    taxKeys () {
      if (this.$store.state.data && this.$store.state.data.company) {
        return {
          1: `Ex`,
          0: `Inc`,
          2: `No ${this.quoteRequest.company.taxCode}`
        }
      } else {
        return {
          1: `Ex`,
          0: `Inc`
        }
      }
    },
    computedRegisteredForTax: {
      get: function () {
        //
        return this.$store.state.data.recipient.isRegisteredForTax
      },
      set: function (oldVal, newVal) {
        //
      }
    },
    computedStepText () {
      let length = (this.quoteRequest && this.quoteRequest.items) ? this.quoteRequest.items.length : 0
      return `${this.owlIndex}/${length}`
    },
    currencySymbol () {
      const currencyCode = this.$i18n.numberFormats[this.$i18n.locale].currency.currency
      return getSymbolFromCurrency(currencyCode)
    }
  }
}
</script>
